import { Component, computed, inject } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { AsyncPipe } from '@angular/common';
import { LocalDatePipe } from '@libs/shared/pipes/local-date.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { OrganizationSettingTypeEnum } from '@libs/types/src/organization/enum/organization-setting-type.enum';
import { OrganizationGlobalStore } from '../../../../store/organization.global-store';
import { isAllowed } from '../../../shared/shared.global-service';
import { featureOn } from '../../../../feature-flag';
import { ButtonComponent } from '../../../../components/kit/button/button.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: 'footer.component.scss',
    imports: [
        LocalDatePipe,
        TranslatePipe,
        AsyncPipe,
        ButtonComponent,
    ],
})
export class FooterComponent {

    private readonly route = inject(ActivatedRoute);
    private readonly router = inject(Router);
    private readonly organizationStore = inject(OrganizationGlobalStore);
    private readonly trashSettingActive = this.organizationStore.isSettingActive(
        OrganizationSettingTypeEnum.TRASH_SETTINGS,
    );
    private readonly navigationEnd = toSignal(
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)),
        { initialValue: null },
    );

    time$: Observable<Date> = timer(0, 1000).pipe(
        map(() => new Date()),
    );

    protected readonly environment = environment;

    protected readonly trashEntityName = computed(() => {
        this.navigationEnd();

        let route: ActivatedRoute | null = this.route;
        let entityName: unknown = null;
        while (route) {
            entityName = route.snapshot.data['trashEntityName'] ?? entityName;
            route = route.firstChild;
        }
        if (typeof entityName === 'string' && entityName) return entityName;
        if (Array.isArray(entityName)) {
            const entityNames = entityName.filter((item): item is string => typeof item === 'string' && Boolean(item));
            return entityNames.length ? entityNames : null;
        }

        return null;
    });

    protected readonly showTrash = computed(() => {
        return featureOn.TRASH
            && this.trashSettingActive() === true
            && this.trashEntityName() !== null
            && isAllowed['trash.read']();
    });

    protected openTrash(): void {
        const entityName = this.trashEntityName();
        void this.router.navigate(['/content/trash'], {
            state: {
                entityType: entityName,
                returnUrl: this.router.url,
            },
        });
    }

}
